/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ParentProfileDto } from '../../models/parent-profile-dto';

export interface ParentProfileControllerFindById$Params {
  id: string;
}

export function parentProfileControllerFindById(http: HttpClient, rootUrl: string, params: ParentProfileControllerFindById$Params, context?: HttpContext): Observable<StrictHttpResponse<ParentProfileDto>> {
  const rb = new RequestBuilder(rootUrl, parentProfileControllerFindById.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ParentProfileDto>;
    })
  );
}

parentProfileControllerFindById.PATH = '/api/parent-profile/{id}';
